import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDetection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 1.5H1.5V2V5H2.5V2.5H4.99993V1.5H2ZM10.9998 2.5H13.4997V5H14.4997V2V1.5H13.9997H10.9998V2.5ZM2.5 11V13.5H4.99993V14.5H2H1.5V14V11H2.5ZM13.4997 11V13.5H10.9998V14.5H13.9997H14.4997V14V11H13.4997ZM6 8.5H7.5V10H6V8.5ZM5 7.5H1.5V8.5H5V10.5V11H5.5H7.5V14.5H8.5V11H10.5H11V10.5V8.5H14.5V7.5H11V5.5V5H10.5H8.5V1.5H7.5V5H5.5H5V5.5V7.5ZM6 7.5V6H7.5V7.5H6ZM8.5 6V7.5H10V6H8.5ZM10 8.5H8.5V10H10V8.5Z"
	})
});
export default SvgDetection;
